export default __webpack_public_path__ + "static/media/iPhone_pick_car.png.webp";